import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { LanguageContext } from "../LanguageContext.jsx";
import bg2 from "../assets/bg-2.png";
import waveTransparent from "../assets/wave-transparent.png";
import waveWhite from "../assets/wave-white.png";

function Activities() {
  const { language } = useContext(LanguageContext);
  return (
    <>
      <Helmet>
        <title>
          Ruiz | {language === "en" ? "Discover Valencia" : "Descubre Valencia"}
        </title>
        <meta
          lang={language}
          name="description"
          content={
            language === "en"
              ? "Discover Cabanyal, Valencia's vibrant and fashionable neighborhood. Explore our comprehensive guide to the best restaurants, activities, and hidden gems that make this district a must-visit spot. Whether you're a local or a visitor, let us help you experience Cabanyal and Valencia like never before."
              : "Descubre Cabanyal, el vibrante y moderno barrio de Valencia. Explora nuestra guía completa de los mejores restaurantes, actividades y lugares escondidos que hacen de este distrito un lugar de visita obligada. Ya sea que seas un local o un visitante, déjanos ayudarte a experimentar Cabanyal y Valencia como nunca antes."
          }
        />
      </Helmet>
      <main>
        <section>
          <div
            className="hero-cabanyal"
            style={{ backgroundImage: `url(${bg2})` }}
          >
            <div className="hero-text">
              <h5>{language === "en" ? "Activities" : "Actividades"}</h5>
              <h1>
                {language === "en" ? "Discover Valencia" : "Descubre Valencia"}
              </h1>
            </div>
            <div className="wave-div">
              <div>
                <img src={waveTransparent} alt="wave for design" />
                <img src={waveWhite} alt="wave for design" />
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Activities;
